import React from "react";
import styled from "styled-components";
import { device } from "../lib/breakpoints";

const SummaryCard = ({
  icon,
  value,
  label,
  subtitle,
  onClick,
  color = "var(--color-primary)",
  backgroundColor = "var(--color-primary-glow)",
  hoverable = true,
}) => {
  return (
    <CardContainer
      $hoverable={hoverable}
      $backgroundColor={backgroundColor}
      onClick={onClick}
    >
      <IconContainer $color={color} className="icon-container">
        {icon}
      </IconContainer>
      <ContentContainer>
        <Value>{value}</Value>
        <Label>{label}</Label>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </ContentContainer>
    </CardContainer>
  );
};

export default SummaryCard;

const CardContainer = styled.div`
  background: white;
  border: 2px solid var(--color-border-light);
  border-radius: 16px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 4px 12px var(--shadow-light);
  transition: all 0.3s ease;
  cursor: ${(props) => (props.$hoverable ? "pointer" : "default")};
  position: relative;
  overflow: hidden;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(44, 95, 45, 0.02) 0%,
      rgba(44, 95, 45, 0.05) 100%
    );
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }

  ${(props) =>
    props.$hoverable &&
    `
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 24px var(--shadow-medium);
      border-color: var(--color-primary);
      
      &:before {
        opacity: 1;
      }
      
      .icon-container {
        transform: scale(1.1);
      }
    }
  `}

  @media ${device.mobile} {
    padding: 1rem;
    gap: 0.75rem;
  }
`;

const IconContainer = styled.div`
  font-size: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: ${(props) => props.$backgroundColor};
  border-radius: 12px;
  color: ${(props) => props.$color};
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;

  @media ${device.mobile} {
    width: 50px;
    height: 50px;
    font-size: 1.5rem;
  }
`;

const ContentContainer = styled.div`
  flex: 1;
  min-width: 0;
`;

const Value = styled.div`
  font-size: 2rem;
  font-weight: 700;
  color: var(--color-text);
  font-family: var(--font-primary);
  line-height: 1;

  @media ${device.mobile} {
    font-size: 1.5rem;
  }
`;

const Label = styled.div`
  font-size: 0.875rem;
  color: var(--color-text-light);
  font-family: var(--font-secondary);
  margin-top: 0.25rem;
  font-weight: 500;
`;

const Subtitle = styled.div`
  font-size: 0.75rem;
  color: var(--color-text-muted);
  font-family: var(--font-secondary);
  margin-top: 0.25rem;
  opacity: 0.8;
`;
